import styled from "@mui/material/styles/styled";

import Stack, { StackProps } from "@rui/Stack";

export const Module = styled((props) => (
  <Stack variant="left" {...props} />
))<StackProps>(({ theme }) => ({
  backgroundColor: "#fff",
  border: `solid 1px ${theme.palette.shades.neutral[100]}`,
  width: "100%",
  borderRadius: "8px",
  maxHeight: "400px",
  overflow: "hidden",
}));

export const NoteListItem = styled(Stack)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(1, 2),
  "&:nth-of-type(even)": {
    backgroundColor: "white",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
}));
